if (!window.SwymCallbacks) window.SwymCallbacks = [];

window.SwymCallbacks.push(function (swat) {
  function updateWishlistCount() {
    swat.fetchLists({
      callbackFn: function (lists) {
        var count = 0;
        lists.forEach(function (list) {
          count += (list.listcontents || []).length;
        });
        // add count to local storage for faster loading on page refresh
        localStorage.setItem('swym_wishlist_count', count);

        var bubbles = document.querySelectorAll('.js-wishlist-count-bubble');

        bubbles.forEach((bubble) => {
          var countEl = bubble && bubble.querySelector('.js-wishlist-header-count');
          if (bubble && countEl) {
            if (count > 0) {
              countEl.textContent = count < 100 ? count : '99+';
              bubble.style.display = '';
            } else {
              bubble.style.display = 'none';
            }
          }
        });
      },
      errorFn: function () {},
    });
  }

  updateWishlistCount();

  // Re-fetch count after any wishlist button click (add/remove)
  document.addEventListener('click', function (e) {
    if (e.target.closest('swymcs-wishlist-button, .js-remove-product')) {
      setTimeout(updateWishlistCount, 800);
    }
  });
});

// load counts from local storage on page load (Swym script takes several seconds to load and update counts)
document.addEventListener('DOMContentLoaded',  () => {
  const storedCount = localStorage.getItem('swym_wishlist_count');
  if (!storedCount) return;

  console.log('Loaded wishlist count from local storage:', storedCount);

  const bubbles = document.querySelectorAll('.js-wishlist-count-bubble');
  bubbles.forEach((bubble) => {
    const countEl = bubble && bubble.querySelector('.js-wishlist-header-count');
    if (bubble && countEl) {
      const count = parseInt(storedCount, 10);
      if (count > 0) {
        countEl.textContent = count < 100 ? count : '99+';
        bubble.style.display = '';
      } else {
        bubble.style.display = 'none';
      }
    }
  });
});